import styled from "styled-components";
import { TextField } from "@mui/material";
import * as React from "react";
import {
    EditModes,
    useTemplateViewEdit,
} from "src/components/providers/template-view-edit-provider";

const TemplateTitleText = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    margin: 0;
`;

const TemplateTitle = ({ text, templateIndex }: { text: string; templateIndex: number }) => {
    const [title, setTitle] = React.useState<string>(text);
    const { editView, onEditMode } = useTemplateViewEdit();

    React.useEffect(() => {
        if (text) setTitle(text);
    }, [text]);

    const saveTitle = () => {
        if (editView) {
            editView({
                templateIndex,
                newTemplate: { title: { value: title } },
                editMode: EditModes.editTemplate,
            });
        }
    };

    if (!onEditMode) return <TemplateTitleText>{title}</TemplateTitleText>;
    return (
        <TextField
            error={false}
            id="outlined-basic"
            label="Title"
            variant="outlined"
            size="small"
            value={title}
            helperText={false}
            style={{ margin: "16px", minWidth: "284px" }}
            onChange={(event) => {
                setTitle(event.target.value);
            }}
            onKeyDown={(event) => {
                if (event.type === "keydown" && event.key === "Enter") {
                    saveTitle();
                }
            }}
            onBlur={() => {
                saveTitle();
            }}
        />
    );
};

export default TemplateTitle;
